export default __webpack_public_path__ + "static/media/pin-red.beb71d1d.png";